export const CREATE_UPDATE_CATEGORY= 'category@create-update-category';
export const DELETE_CATEGORY= 'category@delete-category';
export const GET_CATEGORY= 'category@get-category';
